import {createSelector} from 'reselect';
import {getSystem, getTripData} from './store';
import {getGeneratedLocale, getGeneratedLocaleFormatted, getGeneratedLocaleFull, getDateStringLocale} from '../utils/localeUtils';
import {isInBucket} from '../utils/abacusHelper';

const getArrivedFromExternalSite = createSelector(
    [getSystem],
    (system) => {
        return !!system.arrivedFromExternalSite;
    }
);

const getArrivedFromExternalSiteWithoutDates = createSelector(
    [getArrivedFromExternalSite, getTripData],
    (arrivedFromExternalSite, tripData) => {
        return isInBucket('ha_pdp_direct_dateless_traffic_to_pinned_serp') && arrivedFromExternalSite && tripData.arrivedWithoutDates;
    }
);

const getBrandName = createSelector(
    [getSystem],
    (system) => {
        const brandName = system.humanReadableSiteName && system.humanReadableSiteName.split('.')[0];
        return brandName || '';
    }
);

const getDeviceSize = createSelector(
    [getSystem],
    (system) => {
        return system.deviceSize;
    }
);

const getWidth = createSelector(
    [getSystem],
    (system) => system.width
);

const getHeight = createSelector(
    [getSystem],
    (system) => {
        return system.height;
    }
);

const getIsDesktop = createSelector(
    [getSystem],
    (system) => {
        return system.isDesktop;
    }
);

const getIsMobile = createSelector(
    [getSystem],
    (system) => {
        return system.isMobile;
    }
);

const getCurrency = createSelector([getSystem], (system) => system.currency);

const getLocale = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocale(system.locale);
    }
);

const getLocaleFormatted = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocaleFormatted(system.locale);
    }
);

const getLocaleFull = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocaleFull(system.locale);
    }
);

const getLocaleJS = createSelector(
    [getSystem],
    (system) => {
        return getDateStringLocale(system.locale);
    }
);

const getReviewPageSize = createSelector(
    [getSystem],
    (system) => {
        return system.reviewPageSize;
    }
);

const getSiteName = createSelector(
    [getSystem],
    (system) => {
        return system.siteName;
    }
);

const getSystemClientSideRendered = createSelector(
    [getSystem],
    (system) => {
        return system.clientSideRendered;
    }
);

const getBathroomStrategy = createSelector(
    [getSystem],
    (system) => {
        return system.bathroomStrategy;
    }
);

const getHostName = createSelector(
    [getSystem],
    (system) => {
        return system.hostName;
    }
);

const getBaseUrlPath = createSelector(
    [getSystem],
    (system) => {
        return system.baseUrlPath;
    }
);

export {
    getArrivedFromExternalSite,
    getArrivedFromExternalSiteWithoutDates,
    getBrandName,
    getDeviceSize,
    getWidth,
    getHeight,
    getHostName,
    getIsDesktop,
    getIsMobile,
    getCurrency,
    getLocale,
    getLocaleFormatted,
    getLocaleFull,
    getLocaleJS,
    getReviewPageSize,
    getSiteName,
    getSystemClientSideRendered,
    getBathroomStrategy,
    getBaseUrlPath
};
